import axios from 'axios';
export const getQuoteOptions = async () => {
    const response = await makeRequest('/quotes', 'get');
    return response.data;
};
export const getCurrentQuote = async (order) => {
    const response = await makeRequest('/quotes', 'post', {
        order,
    });
    return response.data;
};
export const submitOrder = async (order) => {
    const response = await makeRequest('/orders', 'post', {
        order,
    });
    return response.data;
};
export const updateOrder = async (id, order) => {
    const response = await makeRequest(`/orders/${id}`, 'put', { order });
    return response.data;
};
export const getOrder = async (id) => {
    const response = await makeRequest(`/orders/${id}.json`, 'get');
    return response.data;
};
async function makeRequest(url, method, data) {
    const token = document.getElementsByName('csrf-token')[0]?.content;
    return axios.request({
        url,
        method,
        data,
        headers: {
            'X-CSRF-Token': token,
        },
        validateStatus: function (status) {
            return (status >= 200 && status < 300) || status === 422;
        },
    });
}
